//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import Vue from 'vue'
// import moment from 'moment'
// import DIC from '@/index/dictonary'

export default {
  components: {
  },
  data: function () {
    return {
      form: {
        address: undefined,
        area: '锦江区',
        city: '成都市',
        dealerId: undefined,
        latitude: '',
        longitude: '',
        pointId: undefined,
        province: '四川省'
      },
      pointOptions: [],
      dealerOptions: [],
      rules: {
      },
      loading: false
    }
  },
  watch: {
    'form.dealerId': {
      handler (val) {
        // console.log('watch.dealerId', val)
        if (val) {
          let f = _.findWhere(this.dealerOptions, {dealerId: val})
          // console.log('f', f)
          // console.log('dealerOptions', this.dealerOptions)
          if (f && f.address) {
            this.form.address = f.address
            let url = encodeURI(`https://apis.map.qq.com/ws/place/v1/search?keyword=${f.address}&boundary=region(成都,0)&page_size=9&page_index=1&key=4XVBZ-7PV6V-7L3PF-UTF4F-AP55Q-PIFLH&output=jsonp&&callback=?`)
            // console.log('url', url)
            $.getJSON(url, (result) => {
              // console.log('result', result)
              let data = result.data[0]
              if (result.count) {
                this.form.area = data.district
                this.form.latitude = ''+data.location.lat
                this.form.longitude = ''+data.location.lng
              }
            })
          }
        }
      }
    },
  },
  mounted () {
    let p1 = new Promise((resolve, reject) => {
      this.$axios.get('/mtea/store/admin/dealer/list', { params: {} }).then(res => {
        this.dealerOptions = res
        if (res && res.length > 0) {
          this.form.dealerId = res[0].dealerId
        }
      }).finally(() => {
        resolve()
      })
    })
    let p2 = new Promise((resolve, reject) => {
      this.$axios.get('/mtea/store/admin/dealer/pick/point/list', { params: {} }).then(res => {
        this.pointOptions = res
        if (res && res.length > 0) {
          this.form.pointId = res[0].pointId
        }
      }).finally(() => {
        resolve()
      })
    })
    Promise.all([p1, p2]).then(() => {
    })
  },
  methods: {
    handleFormSubmit () {
      this.$refs.form.validate((valid) => {
        // console.log('valid', valid)
        if (valid) {
          let data = _.extend({}, _.omit(this.form))
          // console.log('data', data, JSON.stringify(data))
          this.loading = true
          this.$axios.post('/mtea/store/admin/dealer/pick/location/add', data).then(res => {
            this.$router.push({ name: 'operatePurchaseTabs', query: {tab: 'pickLocation'} })
            this.$notify.success({
              title: '系统提示',
              message: '操作成功'
            })
          }).finally(() => {
            this.loading = false
          })
          // this.loading = false
        } else {
          this.$notify.error({
            title: '错误',
            message: '表单校验失败'
          })
        }
      })
    }
  }
}
